import React, { useEffect } from 'react';
import { actions } from 'redux/actions';
import { useSelector } from 'react-redux';
import { _t } from 'utils';
import moment from 'moment';
import Shared from 'screens/shared';
import CreateForm from 'screens/nlb/create';
import { ROUTE } from 'constant';
import { ACTIONS_TYPES } from 'redux/helper';
import ForwardingRules from './forwarding-rule';

export const NLBSingle = ({ history, match }) => {
  const { dcId, id } = match.params;
  const { [ACTIONS_TYPES.NETWORK_LOAD_BALANCER.GET]: networkLoadbalancer = {} } = useSelector((e) => e);
  const { entities = {}, properties = {}, metadata = {} } = networkLoadbalancer;

  useEffect(() => {
    actions.networkLoadbalancer.get({ dcId, id });
  }, [dcId, id]);

  const propertiesRows = [
    ['Name', properties?.name],
    ['Listener Lan', <Shared.utilities.LAN id={properties?.listenerLan} />],
    ['Target Lan', <Shared.utilities.LAN id={properties?.targetLan} />],
    [_t('Last Updated'), moment(metadata?.lastModifiedDate).fromNow()],
    ['IPs', <Shared.utilities.IPs ips={properties?.ips || []} />],
  ];

  const deleteHandler = () => {
    actions.networkLoadbalancer.delete();
    history.goBack();
  };

  return (
    <Shared.widgets.Page
      route={ROUTE.DASHBOARD.NETWORK_LOAD_BALANCER}
      strapIcon="sitemap"
      strapTitle={properties?.name}
      onDelete={deleteHandler}
      editForm={<CreateForm item={{ id, ...properties }} isEdit />}
      editAction={ACTIONS_TYPES.NETWORK_LOAD_BALANCER.UPDATE}
    >
      <Shared.widgets.Properties properties={propertiesRows} />
      <ForwardingRules items={entities?.forwardingrules?.items || []} nlbProperties={properties} {...{ dcId, nlbId: id }} />
    </Shared.widgets.Page>
  );
};
